<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">انبار گردانی محصولات</h5>
                <div style="flex:1"></div>
            </div>
            <div class="card-body">
                <div class="row col-12">
                    <div class="col-6 mb-1">
                        <multiselect placeholder="انتخاب انبار" v-model="selectedStore" open-direction="bottom"
                            :options="stores" label="label" track-by="value" :searchable="true" :close-on-select="true"
                            :show-labels="false" :disabled="disabled">
                            <template slot="noOptions">
                                موردی یافت نشد
                            </template>
                            <template slot="noResult">
                                موردی یافت نشد
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-12">
                        <b-form-group label="انتخاب محصول">
                            <div class="d-flex col-md-6" style="gap: 0.5rem">
                                <b-form-input
                                    autocomplete="off"
                                    ref="productSku"
                                    v-model="productSku"
                                    :disabled="disabled"
                                    @keypress.prevent.enter="requestProduct"
                                    type="text"
                                />
                            </div>
                        </b-form-group>
                        <b-form-group label="جستجوی محصول">
                            <ProductSearch
                                ref="productSearch"
                                :fullWidth="true"
                                :selectable="true"
                                :show-label="false"
                                :store="selectedStore"
                                class="row col-md-12 mb-5"
                                :productOnly="true"
                                @selectProduct="selectProduct"
                            />
                        </b-form-group>
                        <br>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>
                <div class="row mt-5">
                    <table v-if="product" class="table table-responsive-sm table-bordered table-hover">
                        <thead class="bg-light">
                            <tr >
                                <th>ردیف</th>
                                <th>عنوان</th>
                                <th>بارکد</th>
                                <th>موجودی ({{ selectedStore.label }})</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(variety,index) in product.varieties" :key="index">
                                <td class="font-weight-bold">{{ index + 1 }}</td>
                                <td>{{ variety.title }}</td>
                                <td>{{ variety.barcode }}</td>
                                <td class="d-flex justify-content-center">
                                    <b-form-input 
                                        type="number" 
                                        v-model="variety.quantity"
                                        style="max-width: 60%;"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer" v-if="product">
                <div class="d-flex justify-content-center align-items-center">
                    <button class="btn btn-success text-right item-right" @click="submitData">انبار گردانی</button>
                </div>
            </div>  
        </div>
    </main>
</template>
<script>
    import WearehouseManagementLmpl from '@@/core/pages/WearehouseManagement/WearehouseManagementLmpl'
    export default {
        extends: WearehouseManagementLmpl
    }
</script>
<style scoped ></style>